import { CentreSubType, HAZARD_MARKERS, Scheme, UiListTileLeadingColor } from '@/features/hazards';

type CentresToSchemeMap = Record<CentreSubType, Scheme>;

export const centresToSchemeMap: CentresToSchemeMap = {
  [CentreSubType.EvacuationCentreEntity]: {
    leadingColor: UiListTileLeadingColor.Gray,
    icon: HAZARD_MARKERS['ew-reception-centre'],
  },
  [CentreSubType.EvacuationRespiteCentreEntity]: {
    leadingColor: UiListTileLeadingColor.Gray,
    icon: HAZARD_MARKERS['ew-evacuation-supports'],
  },

  // Generic Centre
  [CentreSubType.GenericCentreEntity]: {
    leadingColor: UiListTileLeadingColor.Gray,
    icon: HAZARD_MARKERS['ew-generic-centre'],
  },
};
